import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWifi } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash, faCreditCard } from '@fortawesome/free-regular-svg-icons'
import { Link } from "react-router-dom"
import SignalCard from "../components/SignalCard";
import { formatCurrency, getCurrencySymbol } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";

function Signal() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [see, setSee] = useState(true);
  const usdbal = user?.balance;
  const [signals, setSignals] = useState([]);
  const [mysignal, setMysignal] = useState();
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchSignal: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setSignals(data.signals);
        const mySignal = data.signals.find(signal => signal.signal_id === user.signal_id);
        setMysignal(mySignal);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching signals!')
    })
  }, [user]);
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Signals" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Signals" icon={<FontAwesomeIcon icon={faWifi} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="mycard mt-2" style={{minHeight: '200px'}}>
                            <div className="d-md-flex justify-content-between mb-5">
                                <div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p className="text-secondary fw-bold mb-0">Total Balance: <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '14px'}} onClick={() => {
                                        setSee(see === true ? false : true);
                                        }}/></p>
                                    </div>
                                    <h2 className="fs-4 fw-bold">{see ? `${getCurrencySymbol(user?.currency)}${formatCurrency(usdbal)}` : '******'}</h2>
                                </div>
                                <Link to="/deposit" className="noLink">
                                    <div className="myBtn text-white" style={{fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgba(255, 255, 255, 0.05)'}}><FontAwesomeIcon icon={faCreditCard} style={{fontSize: '14px'}} className="me-1"/> Deposit</div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="mycard mt-2" style={{minHeight: '200px'}}>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="text-secondary fw-bold mb-0">{mysignal?mysignal.signal_name:'No active signal'}</p>
                                <p className="text-prime mb-0 fw-bold" style={{cursor: 'pointer'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(mysignal?mysignal.amount:0)}</p>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-3 mt-5">
                                <h6 className="text-secondary fw-bold mb-0">Signal strength</h6>
                                <h6 className="text-danger fw-bold mb-0">{user?.signals}%</h6>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                {Array(20)
                                .fill()
                                .map((_, i) => (
                                    <div
                                    key={i}
                                    style={{
                                        width: "4%",
                                        height: "12px",
                                        borderRadius: "2px",
                                        backgroundColor: i < user?.signals / 5 ? "rgb(255, 51, 68)" : "rgba(255, 51, 68, 0.5)",
                                        transition: "background-color 0.3s ease-in-out"
                                    }}
                                    ></div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div className="col-12">
                <h5 className="mb-4 fw-bold text-white mt-5 ms-2">Signals</h5>
                <div className="row">
                  {signals.map((signal) => (
                    <div className="col-lg-4 col-6 col-12">
                        <SignalCard key={signal.id} signal_id={signal.signal_id} name={signal.signal_name} price={signal.amount}/>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Signal